import React from "react";
import { Link } from "react-router-dom";

import { getJobMarketStockImage } from "./jobMarketStockImages";
import { getPageCardLink } from "./jobMarketHelpers";

import styles from "./styles/jobMarket.module.css";

function stripHtml(html) {
  if (!html) {
    return "";
  }

  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
}

function getCardDescription(item) {
  if (item.Description && item.Description !== "Страница центра карьеры") {
    return item.Description;
  }

  const bodyText = stripHtml(item.Body);
  if (!bodyText) {
    return item.Description || "";
  }

  return bodyText.length > 160 ? `${bodyText.slice(0, 160)}…` : bodyText;
}

function JobMarketPageCards({ items }) {
  if (!items.length) {
    return (
      <p className={styles.note}>
        Материалы временно недоступны. Загляните позже.
      </p>
    );
  }

  return (
    <div className={styles.cardsGrid}>
      {items.map((item) => {
        const cardLink = getPageCardLink(item);
        const companyName = item.Shortname || item.NameCompany;

        return (
        <div key={item.Id} className={styles.pageCard}>
          <div className={styles.pageCardImage}>
            <img
              src={
                item.ImageLink
                  ? `/v1/api/fileManager/getFile?path=${item.ImageLink}`
                  : getJobMarketStockImage(item.Id)
              }
              alt=""
            />
          </div>
          <div className={styles.pageCardInfo}>
            <div>
              {companyName ? (
                <div
                  className={styles.pageCardCompany}
                  title={companyName}
                >
                  {companyName}
                </div>
              ) : null}
              <div className={styles.pageCardTitle}>{item.Title}</div>
              <div className={styles.pageCardDescription}>
                {getCardDescription(item)}
              </div>
            </div>
            <div className={styles.pageCardFooter}>
              {cardLink ? (
                <Link
                  to={cardLink}
                  className={styles.pageCardMore}
                  target="_blank"
                >
                  Подробнее
                </Link>
              ) : (
                <span className={styles.pageCardMoreDisabled}>Подробнее</span>
              )}
            </div>
          </div>
        </div>
        );
      })}
    </div>
  );
}

export function pickRandomItems(items, count) {
  const shuffled = [...items];

  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled.slice(0, Math.min(count, shuffled.length));
}

export default JobMarketPageCards;
